const SDK_VERSION = '7.118.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
